import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../../../utils/data-load-error/data-load-error";

export enum OrderTransportingOrderForwardingDeleteErrorType {
  ABANDONED_ORDER = "ABANDONED_ORDER",
  DRIVER_ASSIGNED = "DRIVER_ASSIGNED ",
}

export type OrderTransportingOrderForwardingDeleteAbandonedOrderError =
  DataLoadError<
    OrderTransportingOrderForwardingDeleteErrorType.ABANDONED_ORDER,
    {}
  >;

export type OrderTransportingOrderForwardingDeleteDriverAssignedError =
  DataLoadError<
    OrderTransportingOrderForwardingDeleteErrorType.DRIVER_ASSIGNED,
    {}
  >;

type OrderTransportingOrderForwardingDeleteError =
  | OrderTransportingOrderForwardingDeleteAbandonedOrderError
  | OrderTransportingOrderForwardingDeleteDriverAssignedError
  | DataLoadDefaultErrors;

export default OrderTransportingOrderForwardingDeleteError;
